import AsyncLoader from 'component/AsyncLoader';

export const Payment =  AsyncLoader(() => import('./Payment'));
export const UploadList =  AsyncLoader(() => import('./UploadList'));
export const UploadTrial =  AsyncLoader(() => import('./UploadTrial'));
export const CashUploadReview =  AsyncLoader(() => import('./UploadReview'));

